module.exports = __webpack_public_path__ + "static/DTT_Oeil-6cc2118fe12c299b78c11f16eec0e558.svg";